import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '../InfoModal';
import { withLocalization, liveChatOpenHandler } from '../../utils';
import ErrorBlock from '../ErrorBlock';

const ErrorModal = ({ title, content, handleCloseModal, isOpen, t }) => (
  <InfoModal
    title={t(title)}
    onClose={handleCloseModal}
    onButtonClick={handleCloseModal}
    isOpen={isOpen}
    subButtonLabel={t('t.contact.support')}
    onSubButtonClick={liveChatOpenHandler}
  >
    <ErrorBlock>{t(content)}</ErrorBlock>
  </InfoModal>
);

ErrorModal.propTypes = {
  title: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
};

export default withLocalization(ErrorModal);
